/**
 * @module api/publicApi/publicGeneralTradeApi
 */

import secureClient from 'lib/secure-client';
import apiUrl from 'shared_js/helpers/urlHelper/apiUrl';

/**
 * Retrieve General Trade (silkroad) User
 *
 */
function retrieveGeneralTradeUser() {
  return this.get(`${apiUrl}/general-trade/me`, 'user');
}

/**
 * Collection of public user api
 */
const publicAgentApi = secureClient(
  {
    retrieveGeneralTradeUser,
  },
  'xhrPublicAgentApi',
);

export default publicAgentApi;
